import Cookie from 'js-cookie';
import axios from 'axios';
// import { Env } from '@stencil/core';

async function logout(env, redirect_url = '') {

	const logoutApi = `${env}/service/user/xml/logout`;

	try {
		const { data } = await axios.get(
			logoutApi,
			{
				headers: {
					'Accept': 'application/json',
					'X-BrightTALK-access': 'niHeeF1ao2',
					'Content-Type': 'application/json',
					'BrightTALK-API-Client': 'wordpress'
				},
				withCredentials: true
			}
		);
		if (data?.state === 'processed') {
			await logoutUser(env)
			Cookie.remove('btsession_user_id')
			window.location.href = env + '/' + redirect_url
		}
	} catch (error) {
		console.log(error);
	}

}

export const logoutUser = async (env) => {

    try {

        const logoutResponse = await axios.post(`${env}/globalauth-helpercomponent/logout`,
            {}, { withCredentials: true })


        return logoutResponse

    } catch (error) {

        return {}

    }

}

export default logout